import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Products from "./Products";
import Suppliers from "./Suppliers";
import Customers from "./Customers";
import Vehicles from "./Vehicles";
import VehicleTrip from "./VehicleTrip";
import VehicleTripReport from "./VehicleTripReport";
import Purchase from "./Purchase";
import Sale from "./Sale";
import Receipt from "./Receipt";
import Voucher from "./Voucher";
import Expenses from "./Expenses";
import Accounts from "./Accounts";
import SalesReport from "./SalesReport";
import PurchaseReport from "./PurchaseReport";
import AccountReport from "./AccountReport";
import StockReport from "./StockReport";
import DailySummaryReport from "./DailySummaryReport";
import ProfitLossReport from "./ProfitLossReport";
import PaymentsReport from "./PaymentsReport";
import CustomerLedgerReport from "./CustomerLedgerReport";
import SupplierLedgerReport from "./SupplierLedgerReport";
import ExpensesReport from "./ExpensesReport";
import FirmSettings from "./FirmSettings";
import UserSettings from "./UserSettings";
import CustomerBills from "./CustomerBills";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/customer/bills" element={<CustomerBills />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/products" element={<Products />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/vehicles" element={<Vehicles />} />
        <Route path="/vehicle-trip" element={<VehicleTrip />} />
        <Route path="/reports/vehicle-trip" element={<VehicleTripReport />} />
        <Route path="/purchase" element={<Purchase />} />
        <Route path="/sale" element={<Sale />} />
        <Route path="/receipt" element={<Receipt />} />
        <Route path="/voucher" element={<Voucher />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/reports/sale" element={<SalesReport />} />
        <Route path="/reports/purchase" element={<PurchaseReport />} />
        <Route path="/reports/daily-summary" element={<DailySummaryReport />} />
        <Route path="/reports/payments" element={<PaymentsReport />} />
        <Route path="/reports/customer-ledger" element={<CustomerLedgerReport />} />
        <Route path="/reports/supplier-ledger" element={<SupplierLedgerReport />} />
        <Route path="/reports/expenses" element={<ExpensesReport />} />
        <Route path="/reports/profit-loss" element={<ProfitLossReport />} />
        <Route path="/reports/account" element={<AccountReport />} />
        <Route path="/reports/stock" element={<StockReport />} />
        <Route path="/settings/firm" element={<FirmSettings />} />
        <Route path="/settings/user" element={<UserSettings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
